<template>
    <transition name="dropdown">
        <div class="dropdown-filter">
            <div class="row no-gutters" v-if="hasSelection">
                <div class="alink mr-1" v-if="filter.categoria" @click="onRemove('categoria')">
                    <span class="mr-2">CATEGORIA</span><b>{{filter.categoria}}</b>
                </div>
                <div class="alink mr-1" v-if="filter.durata" @click="onRemove('durata')">
                    <span class="mr-2">DURATA</span>
                    <b class="mr-1">{{filter.durata[0]}}</b>-
                    <b>{{filter.durata[1]}}</b>
                </div>
            </div>
            <div class="bg-white">
                <form @submit.prevent>
                    <div class="form-group">
                        <label>Categoria</label>
                        <div :class="`row no-gutters bg-light ${isMobile? 'pl-3 py-1' : 'pl-5 py-3'}`">
                            <div v-for="(item, index) in categories" :key="index" class="col-12 col-md-4 pretty p-default p-curve">
                                <input type="radio" name="categoria" :checked="filter.categoria === item" @click="onSelect('categoria', item)"/>
                                <div class="state p-secondary-o">
                                    <label>
                                        {{item}}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Durata</label>
                        <div :class="`bg-light ${isMobile? 'px-3 py-1' : 'px-5 py-3'}`">
                            <DurationRangeSlider style="max-width: 300px" :min="min" :max="max" :value="filter.durata" @input="onInputDurata"/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import PriceRangeSlider from '../../../common/PriceRangeSlider'
import DurationRangeSlider from '../../../common/DurationRangeSlider'
import MobileDetector from '../../../../common/MobileDetector'

export default {
  name: 'DropdownFilterExperience',
  mixins: [MobileDetector],
  components: {DurationRangeSlider, PriceRangeSlider},
  props: {
    value: Object,
    list: Array
  },
  computed: {
    filter () {
      return this.value
    },
    categories () {
      return this.list.map(item => {
        return item.codiceCategoria.name
      })
    },
    hasSelection () {
      return this.filter.categoria || this.filter.durata
    },
    durations () {
      return this.list.map(item => item.days.length)
    },
    min () {
      return 1
    },
    max () {
      return this.durations.reduce((totale, current) => {
        return Math.max(totale, current)
      })
    }
  },
  methods: {
    ...mapGetters(['getListaServizi']),
    ...mapActions(['modifyExperienceFilter']),
    onSelect (property, item) {
      const filter = {...this.filter, [property]: item}
      this.onChangeFilter(filter)
    },
    onInputDurata (value) {
      const filter = {...this.filter, durata: value}
      this.onChangeFilter(filter)
    },
    onRemove (property) {
      const filter = {...this.filter, [property]: null}
      this.onChangeFilter(filter)
    },
    onChangeFilter: function (filter) {
      this.modifyExperienceFilter(filter)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/pages/experience/dropdown/DropdownFilterExperience.vue